(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Changes', Changes);

    Changes.$inject = ['$resource', 'DateUtils'];

    function Changes ($resource, DateUtils) {
        var resourceUrl =  'api/changes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.issuedDate = DateUtils.convertDateTimeFromServer(data.issuedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
